<template>
  <div>
    <v-dialog v-model="add_calendar_task_modal" max-width="1100" persistent :retain-focus="false">
      <v-card :loading="loading">
        <v-card-title class="pa-0">
          <v-row dense no-gutters>
            <v-col cols="4" style="padding: 10px;">
              <v-autocomplete
                dense
                :items="project_list"
                v-model="project_id"
                item-text="p_name"
                item-value="project_id"
                outlined
                label="Project"
                :error-messages="form_error.project_id"
                :hide-details="!form_error.project_id"
                @change="setProjectId()"
              ></v-autocomplete>
            </v-col>

            <v-col cols="3" class="d-flex justify-center">
              <v-card-title class="pa-0 pt-2">{{ c_task_id ? "Edit" : "Add" }} Calendar Task</v-card-title>
            </v-col>
            <v-col cols="4" class="d-flex justify-end">
              <v-icon size="30" class="mt-2 drag-icon">mdi-drag-variant</v-icon>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-form>
            <v-row dense no-gutters class="grey lighten-1 ma-1 mt-2">
              <v-col cols="3" class="text-center" style="border-right: solid 1px grey">
                <span v-if="item">{{ item.p_name }}</span>
              </v-col>
              <v-col cols="3" class="text-center" style="border-right: solid 1px grey">
                <span v-if="c_name">{{c_name}}</span>
              </v-col>
              <v-col cols="3" class="text-center" style="border-right: solid 1px grey">
                <span v-if="item">Order Date: {{item.display_date}}</span>
              </v-col>
              <v-col cols="3" class="text-center">
                <!-- <span
                  v-if="estimated_completed_date"
                >Est Completion Date: {{estimated_completed_date}}</span>-->
              </v-col>
            </v-row>

            <v-row class="mt-5">
              <v-col cols="2" style="min-width: 33%;">
                <v-autocomplete
                  dense
                  :items="task_list"
                  v-model="form_data.task_id"
                  item-text="text"
                  item-value="value"
                  outlined
                  label="Task"
                  :error-messages="form_error.task_id"
                  :hide-details="!form_error.task_id"
                ></v-autocomplete>
              </v-col>
              <v-col cols="2" style="max-width: 13%;">
                <v-menu
                  ref="start_menu"
                  v-model="start_menu"
                  :close-on-content-click="false"
                  :return-value.sync="start_date"
                  transition="scale-transition"
                  offset-y
                  min-width="270px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="start_date"
                      label="Est. St. Dt"
                      v-bind="attrs"
                      v-on="on"
                      dense
                      outlined
                      :error-messages="form_error.start_date"
                      :hide-details="!form_error.start_date"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    no-title
                    scrollable
                    dense
                    outlined
                    v-model="dateFormattedDisplay"
                    @input="parseDateDisplay()"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="start_menu = false">Cancel</v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.start_menu.save(start_date);changeEndDate();"
                    >OK</v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="2" style="max-width: 10%;">
                <v-text-field
                  dense
                  v-model="form_data.task_days"
                  outlined
                  label="TTL Days"
                  type="number"
                  :error-messages="form_error.task_days"
                  :hide-details="!form_error.task_days"
                  @change="changeEndDate();"
                  @input="changeEndDate();"
                ></v-text-field>
              </v-col>
              <v-col cols="2" style="max-width: 13%;">
                <v-menu
                  ref="end_menu"
                  v-model="end_menu"
                  :close-on-content-click="false"
                  :return-value.sync="end_date"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="end_date"
                      label="Comp. Date"
                      v-bind="attrs"
                      v-on="on"
                      @input="$refs.end_menu.save(end_date);"
                      dense
                      outlined
                      :error-messages="form_error.end_date"
                      :hide-details="!form_error.end_date"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    no-title
                    scrollable
                    dense
                    outlined
                    v-model="dateFormattedDisplayEndDate"
                    @input="parseDateDisplayEndDate()"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="end_menu = false">Cancel</v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.end_menu.save(end_date);changeNoOfTaskDays();"
                    >OK</v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="2" style="max-width:10%">
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :return-value.sync="time"
                  offset-y
                  transition="scale-transition"
                  offset-x
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="form_data.task_time"
                      label="Time"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      dense
                      outlined
                      :error-messages="form_error.task_time"
                      :hide-details="!form_error.task_time"
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    v-if="menu"
                    v-model="form_data.task_time"
                    @input="$refs.menu.save(form_data.task_time)"
                  ></v-time-picker>
                </v-menu>
              </v-col>
              <v-col cols="2">
                <v-autocomplete
                  dense
                  :items="c_task_id ? edit_task_status_list : add_task_status_list"
                  v-model="form_data.task_status"
                  item-text="text"
                  item-value="value"
                  outlined
                  label="Task Status"
                  :error-messages="form_error.task_status"
                  :hide-details="!form_error.task_status"
                  @change="changeStatus()"
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row v-if="form_data.task_status == 5">
              <v-col cols="5">
                <v-checkbox
                  dense
                  hide-details
                  v-model="form_data.is_ext_delay"
                  label="Do you want to add Extension Delay "
                  class="pa-0 ma-0 mt-1"
                ></v-checkbox>
              </v-col>
              <v-col cols="6">
                Delay Due to
                <v-radio-group v-model="form_data.delay_reason" row hide-details class="mt-0" dense>
                  <v-radio label="Customer" value="customer" class="ma-0"></v-radio>
                  <v-radio label="Vendor" value="vendor" class="ma-0 pa-0 pl-2"></v-radio>
                  <v-radio label="Material" value="material" class="ma-0 pa-0 pl-2"></v-radio>
                  <v-radio label="Other" value="others" class="ma-0 pa-0 pl-2"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-textarea
                  dense
                  v-model="form_data.task_note"
                  outlined
                  label="Task Note"
                  rows="2"
                  :error-messages="form_error.task_note"
                  :hide-details="!form_error.task_note"
                ></v-textarea>
              </v-col>

              <!-- <v-col cols="3" v-if="form_data.task_status == 3">
                Schedule Due to
                <v-radio-group
                  v-model="form_data.reschedule_reason"
                  row
                  hide-details
                  class="mt-0"
                  dense
                >
                  <v-radio label="Company" :value="true" class="ma-0 pa-0"></v-radio>
                  <v-radio label="Customer" :value="false" class="ma-0 pa-0 pl-2"></v-radio>
                </v-radio-group>
              </v-col>-->
            </v-row>
            <v-row>
              <v-col cols="4">
                <span style="display: inline-block">
                  <v-checkbox v-model="form_data.is_customer" class="mt-0 pt-0"></v-checkbox>
                </span>
                <span style="display: inline-block; width: 88%">
                  <v-text-field v-model="c_name" label="Customer" dense outlined readonly></v-text-field>
                </span>
              </v-col>
              <v-col cols="4">
                <v-autocomplete
                  dense
                  :items="vendor_list"
                  v-model="form_data.vendor"
                  item-text="text"
                  item-value="value"
                  multiple
                  outlined
                  label="Select Vendor"
                  @change="updateVendorList"
                >
                  <!-- <template v-slot:item="{ item }">
                  <span style="width: 100%">
                    <span>{{ item.text }}</span>
                    <span class="float-right pl-2">
                      <span class="primary--text">{{ item.mobile }}</span>
                    </span>
                  </span>
                  </template>-->
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index === 0">
                      <span>{{ item.text }}</span>
                    </v-chip>
                    <span
                      v-if="index === 1"
                      class="grey--text"
                    >(+{{ form_data.vendor.length - 1 }} others)</span>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="4">
                <v-autocomplete
                  dense
                  :items="user_list"
                  v-model="form_data.user"
                  item-text="text"
                  item-value="value"
                  multiple
                  outlined
                  label="Select User"
                >
                  <!-- <template v-slot:item="{ item }">
                  <span style="width: 100%">
                    <span>{{ item.text }}</span>
                    <span class="float-right pl-2">
                      <span class="primary--text">{{ item.mobile }}</span>
                    </span>
                  </span>
                  </template>-->
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index === 0">
                      <span>{{ item.text }}</span>
                    </v-chip>
                    <span
                      v-if="index === 1"
                      class="grey--text"
                    >(+{{ form_data.user.length - 1 }} others)</span>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="closePopup()" :disabled="loading">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="c_task_id ? saveCalendarTask() : addCalendarTask()"
            :loading="loading"
          >{{ c_task_id ? "Save" : "Add" }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="task_date_modal" max-width="500" persistent :loading="loading">
      <v-card>
        <v-card-title>Task Date</v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col cols="12">
              <v-checkbox
                dense
                v-model="r_e_completed_date_change"
                hide-details
                label="Do you want to change revised estimated completion date?"
                class="mt-0 pt-0"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row dense class="mt-7" v-if="r_e_completed_date_change">
            <v-col cols="6">
              <v-menu
                ref="start_menu"
                v-model="start_menu"
                :close-on-content-click="false"
                :return-value.sync="r_e_completed_date"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="r_e_completed_date"
                    label="Revised Estimated Completion date"
                    prepend-inner-icon="mdi-calendar-clock"
                    class="pretend_icon"
                    v-bind="attrs"
                    v-on="on"
                    dense
                    :error-messages="form_error.r_e_completed_date"
                    :hide-details="!form_error.r_e_completed_date"
                  ></v-text-field>
                </template>
                <v-date-picker
                  no-title
                  scrollable
                  dense
                  outlined
                  v-model="dateFormatted"
                  @input="parseDate()"
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="start_menu = false;form_data={}">Cancel</v-btn>
                  <v-btn text color="primary" @click="$refs.start_menu.save(r_e_completed_date)">OK</v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
            <!-- <v-col cols="auto"><v-btn size="x-small"  color="primary" @click="start_menu=true;">Change Date</v-btn></v-col> -->
          </v-row>
          <v-row dense class="mt-7">
            <v-col cols="12">
              <v-checkbox
                dense
                v-model="subsequent_task_change"
                hide-details
                label="Do you want to change subsequent task?"
                class="mt-0 pt-0"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row dense class="mt-7" v-if="subsequent_task_change">
            <v-col cols="12">
              <v-text-field label="Add Days" dense v-model="subsequent_days" type="number"></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="add_sub_sequent_days=false;task_date_modal = false">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="add_sub_sequent_days=true;task_date_modal=false;change_date=false;change_status=false;"
          >Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "../../plugins/axios";
import { mapState, mapMutations } from "vuex";
import { daysBetweenDates } from "../../plugins/helper";
const moment = require("moment");
export default {
  name: "AddTask",
  data() {
    return {
      loading: false,
      // vendor_list: [],
      // user_list: [],
      // task_list: [],
      add_other_popup: false,
      add_other_loading: false,
      form_data: {
        is_customer: true,
        task_status: 1,
        reschedule_reason: true,
        task_days: 1
      },
      form_error: {},

      add_task_status_list: [
        { text: "Open", value: "1" },
        { text: "Schedule", value: "2" }
      ],
      edit_task_status_list: [
        { text: "Open", value: "1" },
        { text: "Schedule", value: "2" },
        // { text: "Delay", value: "5" },
        { text: "Reschedule", value: "3" }
        // { text: "Complete", value: "4" }
      ],
      dateFormatted: null,
      task_date_modal: false,
      r_e_completed_date_change: false,
      start_menu: false,
      end_menu: false,
      r_e_completed_date: null,
      subsequent_task_change: false,
      subsequent_days: "",
      change_status: false,
      change_date: false,
      old_task_date: "",
      task_order: "",
      old_task_status: "",
      add_sub_sequent_days: false,
      next_task_date: "",
      dateFormattedDisplay: null,
      dateFormattedDisplayEndDate: null,
      end_date: null,
      start_date: null,
      menu: false,
      time: null,
      maxEndDate: null,
      minStartDate: null,
      totalTaskDays: 0,
      project_id: "",
      c_name: ""
    };
  },

  watch: {
    add_calendar_task_modal: {
      handler(val) {
        if (val) {
          this.form_error = {};
          this.form_data = {};
          this.start_date = null;
          this.end_date = null;
          this.c_name = "";
          this.customer = "";

          if (this.calendar_selected_date) {
            this.start_date = moment(
              this.calendar_selected_date,
              "YYYY-MM-DD"
            ).format("MM/DD/YYYY");

            this.dateFormattedDisplay = moment(
              this.calendar_selected_date,
              "YYYY-MM-DD"
            ).format("YYYY-MM-DD");
            this.changeEndDate();
          }
          if (this.p_id) {
            this.project_id = this.p_id;
            this.getProjectDetail();
            this.getStartEndTaskDate();
          }
          if (this.c_task_id) {
            this.getCalendarTaskDetail(this.c_task_id);
            this.getTaskAssignList(this.unique_id);
            this.r_e_completed_date = this.item.revised_completion_date
              ? this.item.revised_completion_date
              : this.item.estimated_completed_date;
            setTimeout(() => {
              this.updateVendorList();
            }, 2000);
          } else {
            this.form_data.is_customer = false;
            this.form_data.task_status = "1";
            this.form_data.task_days = 1;
            this.form_data.task_time = "9:00";
          }
        }
      }
    }
  },
  computed: {
    ...mapState("addtask", [
      "add_calendar_task_modal",
      "p_id",
      "type_module",
      "c_task_id",
      "unique_id",
      "calendar_selected_date",
      "task_list",
      "vendor_list",
      "user_list",
      "project_list"
    ]),
    ...mapState("task", ["item"])
  },

  methods: {
    ...mapMutations("addtask", ["setAddTaskData"]),
    ...mapMutations("task", ["setTaskData"]),
    ...mapMutations("document", ["setDocumentData"]),
    parseDate() {
      const [year, month, day] = this.dateFormatted.split("-");
      this.r_e_completed_date = `${month.padStart(2, "0")}/${day.padStart(
        2,
        "0"
      )}/${year}`;
    },
    parseDateDisplay() {
      const [year, month, day] = this.dateFormattedDisplay.split("-");
      this.start_date = `${month.padStart(2, "0")}/${day.padStart(
        2,
        "0"
      )}/${year}`;
    },
    parseDateDisplayEndDate() {
      const [year, month, day] = this.dateFormattedDisplayEndDate.split("-");
      this.end_date = `${month.padStart(2, "0")}/${day.padStart(
        2,
        "0"
      )}/${year}`;
    },
    updateVendorList() {
      const selectedItems = this.form_data.vendor.map(
        selectedValue =>
          this.vendor_list.find(vendor => vendor.value === selectedValue) || {
            value: selectedValue,
            text: selectedValue // Adjust this based on your data structure
          }
      );
      const remainingItems = this.vendor_list.filter(
        vendor => !this.form_data.vendor.includes(vendor.value)
      );

      this.setAddTaskData({
        key: "vendor_list",
        value: selectedItems.concat(remainingItems)
      });
    },
    changeEndDate() {
      this.end_date = moment(
        moment(this.start_date, "MM/DD/YYYY").add(
          this.form_data.task_days,
          "days"
        )
      ).format("MM/DD/YYYY");
      this.dateFormattedDisplayEndDate = moment(
        moment(this.start_date, "MM/DD/YYYY").add(
          this.form_data.task_days,
          "days"
        )
      ).format("YYYY-MM-DD");
    },
    changeNoOfTaskDays() {
      const start = new Date(this.start_date);
      const end = new Date(this.end_date);

      // Calculate the time difference in milliseconds
      const timeDifference = end - start;

      // Convert milliseconds to days
      const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
      this.form_data.task_days = daysDifference;
    },
    closePopup() {
      this.setAddTaskData({ key: "add_calendar_task_modal", value: false });
    },
    AddSubSequentDays() {
      let _self = this;
      axios
        .post("calendar_task/add_sub_sequent_days", {
          r_e_completed_date_change: _self.r_e_completed_date_change,
          r_e_completed_date: _self.r_e_completed_date,
          subsequent_task_change: _self.subsequent_task_change,
          subsequent_days: _self.subsequent_days,
          task_order: _self.task_order,
          p_id: _self.p_id,
          type: _self.type_module
        })
        .then(function(res) {
          let data = res.data;
          if (!data.status) {
            for (let key in data.errors) {
              _self.form_error[key] = data.errors[key][0];
            }
          } else {
            var item = _self.item;
            item.revised_completion_date = _self.r_e_completed_date;
            _self.setTaskData({ key: "item", value: item });
            _self.$emit("getTaskList");
            _self.task_date_modal = false;
            _self.change_date = false;
            _self.change_status = false;
          }
          _self.loading = false;
        })
        .catch(function(error) {
          console.log("FAILURE!!", error);
          _self.loading = false;
        });
    },
    cancelSearch() {
      if (this.cancelSource) {
        this.cancelSource.cancel("Start new search, stop active search");
        // console.log('cancel request done');
      }
    },

    getStartEndTaskDate() {
      let _self = this;
      _self.cancelSearch();
      _self.cancelSource = axios.CancelToken.source();
      if (_self.project_id) {
        axios
          .get(
            "calendar_task/get_start_end_task_date?o_id=" +
              _self.project_id +
              "&type=" +
              _self.type_module,
            { cancelToken: this.cancelSource.token }
          )
          .then(response => {
            if (response.data.status) {
              let data = response.data;
              _self.maxEndDate = data.maxEndDate;
              _self.minStartDate = data.minStartDate;
              _self.totalTaskDays = data.totalTaskDays;

              if (_self.calendar_selected_date) {
                _self.start_date = moment(
                  _self.calendar_selected_date,
                  "YYYY-MM-DD"
                ).format("MM/DD/YYYY");

                _self.dateFormattedDisplay = moment(
                  _self.calendar_selected_date,
                  "YYYY-MM-DD"
                ).format("YYYY-MM-DD");
              } else {
                _self.start_date = moment(
                  moment(_self.maxEndDate, "YYYY-MM-DD").add(1, "days")
                ).format("MM/DD/YYYY");

                _self.dateFormattedDisplay = moment(
                  moment(_self.maxEndDate, "YYYY-MM-DD").add(1, "days")
                ).format("YYYY-MM-DD");
              }

              _self.changeEndDate();
            }
          })
          .catch(function() {});
      }
    },
    getCalendarTaskDetail(c_task_id = "") {
      let _self = this;
      _self.cancelSearch();
      _self.cancelSource = axios.CancelToken.source();

      axios
        .get("calendar_task/details?c_task_id=" + c_task_id, {
          cancelToken: this.cancelSource.token
        })
        .then(response => {
          if (response.data.status) {
            let data = response.data.data;
            _self.form_data.task_id = data.task_id;
            _self.form_data.task_status = data.task_status;
            _self.start_date = moment(
              data.start_date,
              "YYYY-MM-DD HH:mm:ss"
            ).format("MM/DD/YYYY");
            _self.end_date = moment(
              data.end_date,
              "YYYY-MM-DD HH:mm:ss"
            ).format("MM/DD/YYYY");
            _self.dateFormattedDisplay = moment(
              data.start_date,
              "YYYY-MM-DD HH:mm:ss"
            ).format("YYYY-MM-DD");
            _self.dateFormattedDisplayEndDate = moment(
              data.end_date,
              "YYYY-MM-DD HH:mm:ss"
            ).format("YYYY-MM-DD");
            _self.form_data.task_days = data.task_days;
            _self.form_data.task_time = data.task_time;
            _self.old_task_date = data.task_date;
            _self.next_task_date = data.next_task_date;
            _self.old_task_status = data.task_status;
            _self.form_data.task_note = data.task_note;
            _self.task_order = data.task_order;
            _self.form_data.is_ext_delay =
              data.is_ext_delay == 1 ? true : false;
            _self.form_data.delay_reason = data.delay_reason;
            _self.form_data.reschedule_reason =
              data.reschedule_reason == 1 ? true : false;
          }
        });
    },
    changeStatus() {
      this.change_status = true;
      this.changeTaskAllDate();
    },
    changeDate() {
      this.subsequent_days = daysBetweenDates(
        this.old_task_date,
        this.start_date
      );
      if (this.subsequent_days == 0) {
        this.change_date = false;
      } else {
        this.change_date = true;
        this.r_e_completed_date = moment(
          moment(this.r_e_completed_date, "MM/DD/YYYY").add(
            this.subsequent_days,
            "days"
          )
        ).format("MM/DD/YYYY");
        this.changeTaskAllDate();
      }
    },
    changeTaskAllDate() {
      // console.log(this.start_date, "this.task_date");
      // console.log(this.next_task_date, "this.next_task_date");
      if (
        this.start_date > new Date(this.next_task_date) &&
        (this.form_data.task_status == 2 || this.form_data.task_status == 3)
      ) {
        this.task_date_modal = true;
      }
      // if (
      //   (this.c_task_id && this.change_status && this.change_date && this.form_data.task_status == 3) || (((this.old_task_status == 3 && this.form_data.task_status == 3) ||(this.old_task_status == 2 && this.form_data.task_status == 3) || (this.old_task_status == 2 && this.form_data.task_status == 2)) && this.change_date)
      // ) {
      //   this.task_date_modal = true;
      // }
    },
    getTaskAssignList(unique_id = "") {
      let _self = this;
      axios
        .get("calendar_task/assign_list?unique_id=" + unique_id)
        .then(response => {
          if (response.data.status) {
            let data = response.data.data;
            _self.form_data.is_customer =
              data.customer_count == 0 ? false : true;

            _self.form_data.vendor = [];
            for (let key in data.vendor_task_assignment) {
              _self.form_data.vendor.push(
                data.vendor_task_assignment[key].user_type_id
              );
            }
            _self.form_data.user = [];
            for (let key in data.user_task_assignment) {
              _self.form_data.user.push(
                data.user_task_assignment[key].user_type_id
              );
            }
          }
        });
    },
    addCalendarTask() {
      this.loading = true;
      this.form_error = {};
      let _self = this;
      this.form_data.start_date = moment(this.start_date).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      let serverData = this.form_data;
      let formData = new FormData();
      for (let key in serverData) {
        formData.append(key, serverData[key]);
      }

      formData.append("o_id", this.project_id);
      formData.append("type", this.type_module);
      formData.append("c_task_id", this.c_task_id);
      axios
        .post("calendar_task/add", formData, {
          headers: { "Content-Type": "multipart/form-data" }
        })
        .then(function(res) {
          let data = res.data;
          if (!data.status) {
            for (let key in data.errors) {
              _self.form_error[key] = data.errors[key][0];
            }
          } else {
            _self.$emit("getTaskList");
            _self.change_date = false;
            _self.change_status = false;
            // let item_data = _self.item;
            _self.item.calendartask_count = data.task_count;
            _self.setTaskData({ key: "item", value: _self.item });
            console.log(_self.item, "item");
          }
          _self.closePopup();
          _self.loading = false;
        })
        .catch(function(error) {
          console.log("FAILURE!!", error);
          _self.loading = false;
        });
    },
    saveCalendarTask() {
      this.loading = true;
      this.form_error = {};
      let _self = this;
      this.form_data.start_date = moment(this.start_date).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      let serverData = this.form_data;
      let formData = new FormData();
      for (let key in serverData) {
        formData.append(key, serverData[key]);
      }
      formData.append("o_id", this.project_id);
      formData.append("type", this.type_module);
      formData.append("c_task_id", this.c_task_id);
      axios
        .post("calendar_task/edit", formData, {
          headers: { "Content-Type": "multipart/form-data" }
        })
        .then(function(res) {
          let data = res.data;
          if (!data.status) {
            for (let key in data.errors) {
              _self.form_error[key] = data.errors[key][0];
            }
          } else {
            _self.closePopup();
            _self.$emit("getTaskList");
            if (_self.add_sub_sequent_days == true) {
              _self.AddSubSequentDays();
            }

            _self.change_date = false;
            _self.change_status = false;
            _self.add_sub_sequent_days = false;
          }
          _self.loading = false;
        })
        .catch(function(error) {
          console.log("FAILURE!!", error);
          _self.loading = false;
        });
    },
    setProjectId() {
      let _self = this;
      _self.setTaskData({ key: "p_id", value: _self.project_id });
      _self.getProjectDetail();
      _self.getStartEndTaskDate();
    },
    getProjectDetail() {
      let _self = this;
      let item = _self.project_list.filter(item => {
        if (item.project_id == _self.project_id) {
          return item;
        }
      });
      _self.setTaskData({ key: "item", value: item[0] });
      _self.c_name = item[0]?.customer?.first_name;
    }
  },
  mounted: function() {}
};
</script>
<style>
.radio-margin > .v-input--selection-controls__input {
  margin-right: 2px !important;
}
/* Add CSS styles for the outlined v-datetime-picker */
.v-text-field.outlined .v-label,
.v-text-field.outlined .v-input__control {
  border: 1px solid #757575;
  border-radius: 4px;
}

.v-text-field.outlined:focus-within .v-label,
.v-text-field.outlined:focus-within .v-input__control {
  border-color: #1976d2;
  box-shadow: 0 0 0 2px #1976d2;
}
.pretend_icon .v-icon {
  font-size: 27px !important;
  margin-right: 15px !important;
}
.v-chip:not(.v-chip--active) {
  background: #fff !important;
}
</style>